import { Component, EventEmitter, Input, OnDestroy, OnInit, AfterViewInit, Output, NgZone } from '@angular/core';
import {ArService, AemService, CommonService, DatalayerService , CartService, UserInfoService, OffersData} from 'abs-ngx-library/src/lib/core'
import { IArSubscription, IDataConfig } from 'abs-ngx-library/src/lib/core';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { ProductSNSModalALService } from 'abs-ngx-library/src/lib/quantity-stepper';

// jQuery
declare let $: any;

@Component({
  selector: 'auto-replenishment-al-v1',
  templateUrl: './auto-replenishment-al-v1.component.html'
})
export class AutoReplenishmentALV1Component implements OnInit, AfterViewInit, OnDestroy {

  @Input() product: any;
  @Input() calledBy: string;
  @Input() productDetailPath: string;
  @Input() isBiaLandingPage: boolean;
  @Input()
  public isPcRedesignDisabled: boolean = true;
  @Input() offers: OffersData;

  @Output() setDetailProduct = new EventEmitter<any>();
  @Output() onCheckedOrFrequencyChanged: EventEmitter<any> = new EventEmitter<any>();

  isProductSubscribed: boolean = false;
  subscribedProduct: any;
  isProductLinkToPdp: boolean = false;
  productFulfillDate: string;
  public arSubscriptionList: IArSubscription;
  public productFulfillType: string;
  public showComponent: boolean = false;
  public snsOffer: string = '';
  public selectedFrequency = 1;
  public subscriptionSNS: Subscription;
  public modalFrequencySelected: Subscription;
  public errorModalSnsInfoSubscription: Subscription;
  private subscriptionToaster: Subscription;
  private subscriptionCart: Subscription;
  public isChecked: boolean = false;
  private savedFrequency: number;
  public dataConfig: IDataConfig = {
    modal: '',
    showModal: false,
    prevIdToFocus: '',
    ecomDescription: ''
  };
  public ecomDescription: string = '';

  constructor(
    private _arService: ArService,
    private _aemService: AemService,
    private _productSnsModalService: ProductSNSModalALService,
    private _commonService: CommonService,
    private _datalayerService: DatalayerService,
    private _cartService: CartService,
    private _userInfoService: UserInfoService
    ) {}

  ngOnInit(): void {
    this.isProductLinkToPdp = this.calledBy && this.calledBy !== 'product-detail-item';
    this.dataConfig.contents = this._productSnsModalService.getDynamicContents();
    this.getLatestArSubData();
    this.subscriptionToaster = this._commonService._toasterInteractiveElement.subscribe(val => {
      if(val) {
        this.isChecked = true;
        this.selectedFrequency = this.savedFrequency;
        this.onCheckedOrFrequencyChanged.emit({
          isChecked : true,
          updateCart: true
        });
      }
    })
    this.modalFrequencySelected = this._productSnsModalService.frequencySelected.subscribe((frequency) => {
      if(frequency) {
        this.selectFrequency(frequency);
      }
    });

    this.errorModalSnsInfoSubscription = this._productSnsModalService.errorModalSnsInfo.subscribe((snsInfo) => {
      if(!!snsInfo) {
        this.isChecked = snsInfo.isChecked;
        this.selectedFrequency = snsInfo.selectedFrequency;
        this.onCheckedOrFrequencyChanged.emit({
          isChecked :this.isChecked,
          selectedFrequency: this.selectedFrequency,
          updateCart: false
        });
      }
    });
   
  }

  /**
   * Sets the SNS (Schedule & Save) offer and e-commerce description for the component.
   * Uses flexible discounts logic to get offer details from the offers data.
   */
  setSnsOfferAndEcomDescription() {
    const offer = this._commonService.getOfferWithDeliveryChannelEC(this.offers, this.product.upc, this.product.itemRetailSect);
    this.ecomDescription = offer?.ecomDescription ?? '';

    const percentageMatch = this.ecomDescription.match(/\d+%/);
    this.snsOffer = percentageMatch ? percentageMatch[0] : '';
  };

  ngAfterViewInit(): void {
    // initialize the tooltip
    $(document).ready(function () {
      $('#infoTooltip').tooltip({
        trigger:'manual'
      });
    });
  }

  ngOnDestroy() {
    if(this.subscriptionSNS) {
      this.subscriptionSNS.unsubscribe();
    }
    if (this.subscriptionCart) {
      this.subscriptionCart.unsubscribe();
    }
    if(this.subscriptionToaster) {
      this.subscriptionToaster.unsubscribe();
    }
    if(this.modalFrequencySelected) {
      this.modalFrequencySelected.unsubscribe();
    }
    if(this.errorModalSnsInfoSubscription) {
      this.errorModalSnsInfoSubscription.unsubscribe();
    }
  }

  // send the event to parent - product-details component
  public checkValue(event: any): void {
    if(event.srcElement.checked) {
      this.isChecked = true;
      if(this._commonService._hasLSArSubscriptions() && this.arSubscriptionList && this.arSubscriptionList['isCheckboxFirstTimeChecked'] == false ) {
        // show the tooltip
        $('#infoTooltip').tooltip('show');
        // set the local storage value to true
        this.arSubscriptionList['isCheckboxFirstTimeChecked'] = true;
        this.arSubscriptionList['showHeaderTooltip'] = true;
        this._commonService.showHeaderTooltip.next(true);

        this._arService._setSubscriptionsToLS(this.arSubscriptionList);
        $(document).on('click', function() {
          $('#infoTooltip').tooltip('hide');
        });
        // hide the tooltip after 6 seconds
        setTimeout(()=>{
          $('#infoTooltip').tooltip('hide');
          },6000);
      }
    } else {
      this.isChecked = false;
      this.savedFrequency = this.selectedFrequency;
      this.selectedFrequency = 1;
      $('#infoTooltip').tooltip('hide');
    }
    this.onCheckedOrFrequencyChanged.emit({
      isChecked : this.isChecked,
      isFirstTimeSnsSub : this.arSubscriptionList.isNewSnSUser, updateCart: true});
      if (window['AB']?.DATALAYER) {
          window['AB'].DATALAYER.snsCheckboxClick(this.isChecked, this.product, this.selectedFrequency);
      }
  }

  public getLatestArSubData(){
    // subscribing to the behavioral subject - arSubscriptions
    this.subscriptionSNS = this._commonService.arSubscriptions.subscribe((data) => {
      if(!!data) {
        if(!this._commonService.isEmpty(data)) {
          this.arSubscriptionList = data;
          this.checkForArProductDetails();
          this.setSnsOfferAndEcomDescription();
          this.showComponent= true;
          if(!this.isProductLinkToPdp) {
            this.processProductSNSInformation();
          }
        } else {
          this.setSnsOfferAndEcomDescription();
          this.showComponent= true;
        }
      } else {
        this.setSnsOfferAndEcomDescription();
        this.showComponent= true;
      }
    });
  }

  private processProductSNSInformation() {
    const abCartLS = this._cartService._get();
    if(!this._commonService.isEmpty(abCartLS)) {
      this.performSideEffects(abCartLS);
    } else {
      this.subscriptionCart = this._commonService.currentCartObj.pipe(take(2)).subscribe((cartObj) => {
        if(!this._commonService.isEmpty(cartObj)) {
          this.performSideEffects(cartObj);
        }
      })
    }
  };

  private performSideEffects (objCart) {
    if(!this._commonService.isEmpty(objCart['cart'])) {
      let matchingItem:any;
      const isB2BSite = this._userInfoService.getSiteType() === 'B';
      if(isB2BSite){
        matchingItem = objCart['cart'].hasOwnProperty('1P_B2B') && objCart['cart']['1P_B2B']['cartItems'].length > 0 && objCart['cart']['1P_B2B']['cartItems'].find(item => item.itemId == this.product.id);
      } else {
        matchingItem = objCart['cart'].hasOwnProperty('abs') && objCart['cart']['abs']['cartItems'].length > 0 && objCart['cart']['abs']['cartItems'].find(item => item.itemId == this.product.id);
      }
      if ((matchingItem && matchingItem.hasOwnProperty('snsSub') && matchingItem.snsSub.isSnsSub)) {
        this.isChecked = true;
        this.selectedFrequency = matchingItem.snsSub.snsFrequency.count;
        this.onCheckedOrFrequencyChanged.emit({
          isChecked : this.isChecked,
          selectedFrequency : this.selectedFrequency,
          updateCart: false
        });
      }
    }
  };

  public showModal(type: string, prevIdToFocus: string) {
    this.dataConfig.modal = type;
    this.dataConfig.showModal = true;
    this.dataConfig.prevIdToFocus = prevIdToFocus;
    switch(type) {
      case 'freqModal':
            this.dataConfig.selectedFrequency = this.selectedFrequency;
            this.dataConfig.frequencies = this.arSubscriptionList['snsFrequencies'] && this.arSubscriptionList['snsFrequencies'].length > 0 ? this.arSubscriptionList['snsFrequencies'] : this._arService.getStaticFrequencyList();
            break;
      case 'addRecurringModal':
            this.dataConfig.product = this.product;
            this.dataConfig.frequencies = this.arSubscriptionList['snsFrequencies'] && this.arSubscriptionList['snsFrequencies'].length > 0 ? this.arSubscriptionList['snsFrequencies'] : this._arService.getStaticFrequencyList();
            this.dataConfig.nextFulfillmentType = this.arSubscriptionList.fulfillment?.fulfillmentType ? this.arSubscriptionList.fulfillment.fulfillmentType?.toLowerCase() : '';
            this.dataConfig.nextFulfillmentDate = this.arSubscriptionList.fulfillment?.nextOrderFulfillmentDate ? this.arSubscriptionList.fulfillment.nextOrderFulfillmentDate : '';
            this.dataConfig.subscriptionSource = this.calledBy;
            this.dataConfig.ecomDescription = this.ecomDescription;
            break;
    }
    this._productSnsModalService.show(this.dataConfig);
    if (window['AB']?.DATALAYER) {
      window['AB'].DATALAYER.setSnsModalViewEvents(this.dataConfig, this.product, this.isChecked, this.selectedFrequency);
    }
  }

  public selectFrequency(value: number){
    this.selectedFrequency = value;
    this.onCheckedOrFrequencyChanged.emit({selectedFrequency: this.selectedFrequency, updateCart: true});
  }

  public checkForArProductDetails() {
    this.subscribedProduct = this.arSubscriptionList && this.arSubscriptionList['subscribedItems'][this.product.id];
    if(this.subscribedProduct) {
      if(this.arSubscriptionList['fulfillment'] && !this._commonService.isEmpty(this.arSubscriptionList['fulfillment'])){
        this.productFulfillType = this.arSubscriptionList['fulfillment']['fulfillmentType'].toLowerCase();
        this.isProductSubscribed = this.subscribedProduct['isActiveSubscription'] ? this.subscribedProduct['isActiveSubscription'] : this.subscribedProduct['subscriptionActive'];

        // AR Subscription Date
        this.productFulfillDate =  this.subscribedProduct['nextFulfillmentDate'];

      } else {
        this.productFulfillType = this.arSubscriptionList['fulfillmentType'].toLowerCase();
        this.isProductSubscribed = this.subscribedProduct['isActiveSubscription'] ? this.subscribedProduct['isActiveSubscription'] : this.subscribedProduct['subscriptionActive'];

        // AR Subscription Date
        this.productFulfillDate = this.subscribedProduct['fulfillmentDate'];
      }
    }
  }

  public isProductOutOfStock()
  {
    if(!this.isPcRedesignDisabled){
      return !this._commonService.isItemAvailable_v3(this.product,'',true);
    }
    if (this.isBiaLandingPage) {
      return !this._commonService.isItemAvailable_v3(this.product);
    }
    return !this._commonService.isItemAvailable_v2(this.product);
  }

  getARManageLink() {
    return `${window.location.origin}/schedule-and-save/manage`;
  }

  /**
   * @return sns ecom description with percent as string
   * Replacing % with percent since screen readers not recognizing '%'
   * **/
  public adaSnsOfferTitle (): string {
    return this.ecomDescription ? this.ecomDescription.replace('%', 'percent') : '';
  }

    /**
 * This method will process whether to redirect the user to PDP page or to fire "Add to recurring order" Modal.
   * For MLP redirect all users to PDP pages when clicking on SNS links from Product cards
 * **/

  public processSnsAction(prevElementId: string) {
    if (this._datalayerService.getDataLayer()) {
      this._datalayerService.setSnsLinkClick(this.snsOffer);
    }
    this._commonService.sendSponsoredProductClickEvent(this.product,'autoReplenishment','scheduleAndSave');
    if(this.arSubscriptionList && this.arSubscriptionList.isNewSnSUser) {
      window.location.href =  this.productDetailPath;
    } else {
      this.showModal('addRecurringModal', prevElementId);
    }
    
  }

  public analyticPickupDeliveryClick(event) {
    if (window['AB'] && window['AB'].DATALAYER) {
      window['AB'].DATALAYER.snsNextPickupDeliveryClick(event, this.calledBy, this.productFulfillType, this.productFulfillDate);
    }
  }

  public analyticsManageLinkClick() {
    if (window['AB'] && window['AB'].DATALAYER) {
      window['AB'].DATALAYER.analyticsCTATracking(`cta:${window['AB'].DATALAYER.pathSections?.join(':')}|link|pdp-manage-ss`);
    }
  }
}
